import { render, staticRenderFns } from "./active_invitations.vue?vue&type=template&id=ff32f8e8&scoped=true"
import script from "./active_invitations.vue?vue&type=script&lang=js"
export * from "./active_invitations.vue?vue&type=script&lang=js"
import style0 from "./active_invitations.vue?vue&type=style&index=0&id=ff32f8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff32f8e8",
  null
  
)

export default component.exports